import { Calculator as CalculatorPresenter } from './presenter';
import { connect } from '../../../../react-redux';
import { getActiveCalculatorId } from '../../../../../common/selectors/ui';
import { hasVisibleQuestionCalculator } from '../../../../../common/selectors/calculator';
import { setActiveCalculatorId } from '../../../../../common/actions/ui';
import { getActiveQuizSessionId } from '../../../../selectors/quizSessions';
import { getActiveQuizCaluclatorType } from '../../../../selectors/quizzes';
var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCalculatorId: getActiveCalculatorId(state),
    calculatorType: hasVisibleQuestionCalculator(state) ? 'none' : getActiveQuizCaluclatorType(state),
    quizSessionId: getActiveQuizSessionId(state)
  };
};
var mapDispatchToProps = {
  setActiveCalculatorId: setActiveCalculatorId
};
export var Calculator = connect(mapStateToProps, mapDispatchToProps)(CalculatorPresenter);
export default Calculator;